import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { reduxForm } from 'redux-form';

import { Icon, Message } from 'semantic-ui-react';

import { ModalTemplate, Button, Loading, ReduxFormMaterialTextField } from 'components';

import * as common from 'libs/commonFunc';

import styles from '../../../style/modal.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class ModalEditPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null
    };
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { isClicked, editPasswordData } = this.props;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-editPassword-area', 'common-content')}
        visible
        onToggleModal={editPasswordData.onToggleModal}
        header={defineMessages(formatMessage({ id: 'ModalEditPassword_1', defaultMessage: '비밀번호 변경' }))}
        buttons={
          <div className={cx('inline-block')}>
            <Button
              buttonColor="#bbbbbb"
              onClick={() => {
                editPasswordData.onToggleModal('');
              }}>
              {defineMessages(formatMessage({ id: 'ModalEditPassword_3', defaultMessage: '취 소' }))}
            </Button>
            <Button
              className={cx('brand-button')}
              disabled={isClicked}
              loading={isClicked}
              onClick={editPasswordData.onSaveEditPassword}>
              {defineMessages(formatMessage({ id: 'ModalEditPassword_2', defaultMessage: '변 경' }))}
            </Button>
          </div>
        }>
        <div className={cx('modal-content')}>
          <Loading active={isClicked} size="small" content="Waiting..." />
          <div>
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'ModalEditPassword_4', defaultMessage: '기존 비밀번호' }))}
            </span>
            <ReduxFormMaterialTextField
              className={cx('input-area')}
              type="password"
              // label={defineMessages(formatMessage({ id: 'ModalEditPassword_4', defaultMessage: '기존 비밀번호' }))}
              fullWidth
              validate={['required', 'gsPassword']}
              name="beforePassword"
              checkType={101}
              error={editPasswordData.errorMessage.type === 'beforePassword' ? true : false}
              errorText={
                editPasswordData.errorMessage.type === 'beforePassword' && editPasswordData.errorMessage.content
              }
              // helperText={
              //   editPasswordData.errorMessage.type === 'beforePassword' && editPasswordData.errorMessage.content
              // }
            />
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'ModalEditPassword_5', defaultMessage: '새 비밀번호' }))}
            </span>
            <ReduxFormMaterialTextField
              className={cx('input-area')}
              type="password"
              // label={defineMessages(formatMessage({ id: 'ModalEditPassword_5', defaultMessage: '새 비밀번호' }))}
              fullWidth
              validate={['required', 'gsPassword']}
              name="newPassword"
              checkType={101}
              error={editPasswordData.errorMessage.type === 'newPassword' ? true : false}
              errorText={editPasswordData.errorMessage.type === 'newPassword' && editPasswordData.errorMessage.content}
              // helperText={editPasswordData.errorMessage.type === 'newPassword' && editPasswordData.errorMessage.content}
            />
            <span className={cx('materialTextField-title')}>
              {defineMessages(formatMessage({ id: 'ModalEditPassword_6', defaultMessage: '새 비밀번호 확인' }))}
            </span>
            <ReduxFormMaterialTextField
              className={cx('input-area')}
              type="password"
              // label={defineMessages(formatMessage({ id: 'ModalEditPassword_6', defaultMessage: '새 비밀번호 확인' }))}
              fullWidth
              validate={['required', 'gsPassword']}
              name="newPasswordAgain"
              checkType={101}
              error={editPasswordData.errorMessage.type === 'newPasswordAgain' ? true : false}
              errorText={
                editPasswordData.errorMessage.type === 'newPasswordAgain' && editPasswordData.errorMessage.content
              }
              // helperText={
              //   editPasswordData.errorMessage.type === 'newPasswordAgain' && editPasswordData.errorMessage.content
              // }
            />
            {editPasswordData.errorMessage.type === 'success' && (
              <Message success>
                <Message.Header>
                  <Icon name="check circle" />
                  {editPasswordData.errorMessage.content}
                </Message.Header>
              </Message>
            )}
          </div>
        </div>
      </ModalTemplate>
    );
  }
}

export default reduxForm({
  form: 'formEditPassword',
  enableReinitialize: true
})(injectIntl(ModalEditPassword));



// WEBPACK FOOTER //
// ./src/script/components/modal/ModalEditPassword.js